export default {
    
    SET_BankTransfersBrokers(state, BankTransfersBrokers) {
      debugger;
      try {
       
        state.BankTransfersBrokers = BankTransfersBrokers;
        
      } catch (error) {
        console.error("Failed to parse BrokerPackage data JSON:", error);
        state.BankTransfersBrokers = [];
      }
    },
    SET_BankTransfersSP(state, BankTransfersSP) {
        debugger;
        try {
         
          state.BankTransfersSP = BankTransfersSP;
          
        } catch (error) {
          console.error("Failed to parse BrokerPackage data JSON:", error);
          state.BankTransfersSP = [];
        }
      },
    SET_Packages(state, Packages) {
      debugger;
      try {
        //const parsedData = JSON.parse(countries);
        state.Packages = Packages;
        //state.OutbreakCountries =  countries;
      } catch (error) {
        console.error("Failed to parse Packages data JSON:", error);
        state.Packages = [];
      }
    },
    Confirm_TransferSPs(state, BankTransfersSP) {
      debugger;
      const transferIndex = state.BankTransfersSPs.findIndex((p) => p.Id == BankTransfersSP.Id)
      Object.assign(state.BankTransfersSPs[transferIndex], BankTransfersSP)
    },
    Confirm_TransferBrokers(state, BankTransfersBroker) {
        debugger;
        const transferIndex = state.BankTransfersBrokers.findIndex((p) => p.Id == BankTransfersBroker.Id)
        Object.assign(state.BankTransfersBrokers[transferIndex], BankTransfersBroker)
      }
  }
  